import React from "react";
import PropTypes from "prop-types";
import QueryString from "query-string";

import AdvancedDownloadModal from "@components/advanced_download/main";
import UploadArea from "@components/common/filestack_uploader/upload_area";
import BoulderIFrame from "./boulder_iframe";

class ImageSelector extends React.Component {
  state = {
    imageSource: this.defaultImage,
    filename: null,
    attachmentKey: null,
    renderIFrame: false,
    renderCropper: false,
  }

  get defaultImage() {
    const { client, jobId, frame, imageFrameData } = this.props;
    return imageFrameData[frame.id] && imageFrameData[frame.id].displayUrl
      ? imageFrameData[frame.id].displayUrl
      : `https://ids.w2p-tools.com/d003/getimagethumbnail.php?c=${client}&id=${jobId}&imgout=png&f=${frame.value}&bbox=300`;
  }

  updateImageSelector = ({ key, filename, crop }) => {
    if (!key) {
      this.setState({ renderIFrame: false });
      Notify.create({ type: "error", title: "Embed failed", body: "Please try again." });
      return; // just close iframe
    }

    const correctedFilename = filename.replace(/\s+/g, '-');
    if (crop) {
      this.setState({ attachmentKey: key, filename: correctedFilename, renderCropper: true, renderIFrame: false });
    } else {
      const imageParams = "" //`?height=${this.defineHeight()}&width=${this.defineWidth()}&crop=true`;
      const { embedLink, updateFrameData, frame, validations } = this.props;
      const cdnLink = `${BFG.smartCDNRoot}/${embedLink}/at/${key}/${correctedFilename}${imageParams}`;
      updateFrameData({ [frame.id]: { url: cdnLink, name: correctedFilename } }, "image");
      this.setState({ renderIFrame: false, imageSource: cdnLink });
    }
  }

  genericUpload = (files) => {
    const { updateFrameData, frame } = this.props;
    const url = files[0].url;
    const name = files[0].filename;
    this.setState({ imageSource: url, renderIFrame: false });
    updateFrameData({ [frame.id]: { url, name } }, "image");
  }

  defineWidth = () => {
    const { points } = this.props.frame;
    const xCoordinates = points.map((point) => parseFloat(point[0]));
    const width = Math.abs(Math.max(...xCoordinates) - Math.min(...xCoordinates));
    return parseInt(width, 10);
  }

  defineHeight = () => {
    const { points } = this.props.frame;
    const yCoordinates = points.map((point) => parseFloat(point[1]));
    const height = Math.abs(Math.max(...yCoordinates) - Math.min(...yCoordinates));
    return parseInt(height, 10);
  }

  defineAspectRatio = () => (this.defineWidth() / this.defineHeight());

  showIframe = () => {
    const { frame, orgSlug, printuiInput } = this.props;
    return (
      <BoulderIFrame
        frame={frame}
        updateImageSelector={this.updateImageSelector}
        printuiInput={printuiInput}
        orgSlug={orgSlug}
      />
    );
  }

  handleDownloadLink = (cdnParams) => {
    const { embedLink, updateFrameData, frame } = this.props;
    const { attachmentKey, filename } = this.state;
    const cdnLink = `${BFG.smartCDNRoot}/${embedLink}/at/${attachmentKey}/${filename}?${QueryString.stringify(cdnParams)}`;
    updateFrameData({ [frame.id]: { url: cdnLink, name: filename } }, "image");
    this.setState({ imageSource: cdnLink, renderCropper: false, renderIFrame: false });
  }

  showCropper = () => (
    <AdvancedDownloadModal
      lastVisited={{ attachmentKey: this.state.attachmentKey }}
      resetShowModal={() => this.setState({ renderCropper: false })}
      shouldCloseOnOverlayClick={false}
      resource={BF.fx.brandfolder()}
      lockedPreset={{
        name: "Template Cropping",
        width: this.defineWidth(),
        height: this.defineHeight(),
        aspectRatio: this.defineAspectRatio()
      }}
      handleDownloadLink={this.handleDownloadLink}
    />
  )

  renderExistingImage = () => {
    const { validations, frame } = this.props;
    const { imageSource } = this.state;
    return (
      <div className="image-card">
        <div className="image-container">
          <img className="existing-image" src={imageSource} alt="bf-template" />
          <div className="dimensions">{`${this.defineWidth()} x ${this.defineHeight()}`}</div>
        </div>
        { validations.image_replacement !== "deny_replacement" ? (
          <div className="image-swap">
            { validations.image_replacement !== "allow_only_upload" ? (
              <span className="embed-printui-image">
                <button
                  onClick={() => this.setState({ renderIFrame: true })}
                  className="button secondary"
                  type="button"
                >
                  {t('Select from Brandfolder')}
                </button>
              </span>
            ) : null }
            { (validations.image_replacement !== "allow_only_embed")
              ? (
                <div className="upload-printui-image">
                  <UploadArea
                    type="button"
                    hideIcon
                    uploadType="generic-upload"
                    uniqDomElement={`printui-upload-area-${frame.id}`}
                    options={{
                      maxFiles: 1,
                      accept: ["image/*", "application/postscript", "application/pdf"],
                      transformations: {
                        crop: {
                          aspectRatio: this.defineAspectRatio(),
                          force: true } } }}
                    genericUpload={this.genericUpload}
                  />
                </div>
              ) : null }
          </div>
        ) : null }
      </div>
    );
  }

  render() {
    const { renderIFrame, renderCropper } = this.state;
    return (
      <React.Fragment>
        { renderIFrame && this.showIframe()}
        { renderCropper && this.showCropper()}
        { (!renderIFrame && !renderCropper) ? this.renderExistingImage() : null }
      </React.Fragment>
    );
  }
}

ImageSelector.propTypes = {
  frame: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.string,
    name: PropTypes.string,
    points: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  }).isRequired,
  updateFrameData: PropTypes.func.isRequired,
  orgSlug: PropTypes.string.isRequired,
  client: PropTypes.string.isRequired,
  jobId: PropTypes.string.isRequired,
  validations: PropTypes.shape({
    image_replacement: PropTypes.string,
    embed_settings: PropTypes.string
  }).isRequired,
  embedLink: PropTypes.string.isRequired,
  imageFrameData: PropTypes.shape({}).isRequired,
  printuiInput: PropTypes.shape({
    key: PropTypes.string,
    field_identifier: PropTypes.string,
    options: PropTypes.object,
    validations: PropTypes.object
  }),
};

ImageSelector.defaultProps = {
  printuiInput: null
};

export default ImageSelector;
